import * as Joi from 'joi'

import {
  validateCardholderName,
  validateCardSecurityCode,
  validateCreditCardExpiryDate,
  validateCreditCardNumber,
} from '../utils'
import { CreditCardForm } from '../types'

export const creditCardSchema = Joi.object<CreditCardForm>({
  brand: {
    id: Joi.string().required(),
    name: Joi.string().required(),
    icon: Joi.string().optional().allow('', null),
  },
  expiryDate: Joi.string()
    .required()
    .custom(validateCreditCardExpiryDate)
    .messages({
      'string.invalid': 'Validade expirada',
      'string.min': 'Data inválida',
      'string.empty': 'Campo obrigatório',
    }),
  holderName: Joi.string().required().custom(validateCardholderName).messages({
    'string.invalid': 'Nome inválido',
    'string.empty': 'Campo obrigatório',
  }),
  number: Joi.string().required().custom(validateCreditCardNumber).messages({
    'string.invalid': 'Número de cartão inválido',
    'string.min': 'Número de cartão inválido ou não aceito',
    'string.empty': 'Campo obrigatório',
  }),
  securityCode: Joi.string()
    .custom(validateCardSecurityCode)
    .required()
    .messages({
      'string.min': 'Mínimo de 3 dígitos',
      'string.empty': 'CVV é obrigatório',
    }),
  paymentMethodType: Joi.string().valid('CREDIT_CARD').required(),
  accountId: Joi.string().uuid().required(),
})
